export const DashboardType = {
    indicators: { id: 'indicadores', name: 'Dashboard de Indicadores' },
    salasReuniao: { id: 'salas-reuniao', name: 'Salas de Reunião' },
    restaurantes: { id: 'restaurantes', name: 'Restaurantes' },
};

export const DashboardTypes = [
    DashboardType.indicators,
    DashboardType.salasReuniao,
    DashboardType.restaurantes
];